import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DEFAULT_OG_IMAGE, pagePathToUrl, toAbsoluteImageUrl } from './constants';

export interface PageSeoProps {
    title: string;
    description: string;
    path: string;
    image?: string;
    imageAlt?: string;
    jsonLd?: Record<string, unknown> | Record<string, unknown>[];
    noIndex?: boolean;
}

const PageSeo: React.FC<PageSeoProps> = ({
    title,
    description,
    path,
    image = DEFAULT_OG_IMAGE,
    imageAlt,
    jsonLd,
    noIndex = false,
}) => {
    const canonicalUrl = pagePathToUrl(path);
    const ogImage = toAbsoluteImageUrl(image);

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {noIndex && <meta name="robots" content="noindex, nofollow" />}
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Galia Standard Poodles" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={ogImage} />
            {imageAlt && <meta property="og:image:alt" content={imageAlt} />}

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />
            {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
};

export default PageSeo;
